import { render, staticRenderFns } from "./RiskQuestionnaireButton.vue?vue&type=template&id=3d4b9de3&"
import script from "./RiskQuestionnaireButton.vue?vue&type=script&lang=js&"
export * from "./RiskQuestionnaireButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports